import { useEffect, useState } from "react";
import {useDispatch, useSelector} from 'react-redux';
import {latitude, longitude} from "@/store/slices/geoLocationSlice";
import {RootState} from "@/store/store";

const useGeolocation = () => {
    const dispatch = useDispatch();
    const [userLatitude, setUserLatitude] = useState<number | null>(null)
    const [userLongitude, setUserLongitude] = useState<number | null>(null)

    const userLatitudeRedux = useSelector((state: RootState) => state.geolocation.latitude)

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setUserLatitude(position.coords.latitude)
                    setUserLongitude(position.coords.longitude)
                },
                (error) => {
                    console.error("Error getting the location:", error)
                },
            );
        } else {
            console.log("Geolocation is not supported by this browser.")
        }
    }, [])

    dispatch(latitude(userLatitude))
    dispatch(longitude(userLongitude))

    return { userLatitude, userLongitude }

};

export default useGeolocation;
